import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail } from 'lucide-react';
import { useSeo } from '../utils/useSeo';

const CONTACT_EMAIL = 'klinikvet.app@gmail.com';

const FAQ: { q: string; a: string }[] = [
  {
    q: 'Mobil uygulamaya nasıl giriş yaparım?',
    a: 'Veteriner kliniğinize kayıtlı e-posta adresinizi girin; e-postanıza gelen kodu yazarak giriş yaparsınız. Kayıt bulunamazsa lütfen kliniğinizle iletişime geçin.',
  },
  {
    q: 'Kod e-postama gelmiyor.',
    a: 'Spam veya gereksiz klasörünüzü kontrol edin. Birden fazla kod istediyseniz yalnızca en son gelen kod geçerlidir.',
  },
  {
    q: 'Hesabımı nasıl silerim?',
    a: 'Mobil uygulamada Profil sayfasındaki "Hesabı Sil" seçeneğini kullanın. Silme sonrası bu e-postayla uygulamaya tekrar giriş yapılamaz. Hayvanlarınıza ait klinik kayıtları kliniğin yasal kayıtlarıdır ve klinikte kalır; silinmesini kliniğe talep edebilirsiniz.',
  },
  {
    q: 'Verilerimin bir kopyasını nasıl alırım?',
    a: 'Veterinerinizle veya klinik yöneticisiyle iletişime geçebilir ya da bize e-posta gönderebilirsiniz.',
  },
];

const SupportPage: React.FC = () => {
  useSeo({
    title: 'Destek | KlinikVet',
    description: 'KlinikVet mobil uygulaması ve web paneli için destek, sık sorulan sorular ve iletişim.',
    path: '/destek',
  });
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-3xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 font-semibold text-gray-900">
            <span className="w-8 h-8 rounded-lg bg-teal-700 flex items-center justify-center"><img src="/brand-symbol.png" alt="" className="h-5 w-auto" /></span> KlinikVet
          </Link>
          <Link to="/" className="text-sm text-gray-600 flex items-center gap-1">
            <ArrowLeft className="h-4 w-4" /> Ana sayfa
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 py-10">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Destek</h1>
        <p className="text-gray-600 mb-8">Sorularınız için size yardımcı olmaktan memnuniyet duyarız. E-postalara genellikle 2 iş günü içinde yanıt veriyoruz.</p>
        <a
          href={`mailto:${CONTACT_EMAIL}`}
          className="inline-flex items-center gap-2 bg-teal-700 text-white px-5 py-3 rounded-xl font-medium mb-10"
        >
          <Mail className="h-5 w-5" /> {CONTACT_EMAIL}
        </a>
        <h2 className="text-xl font-semibold text-gray-900 mb-4">Sık sorulan sorular</h2>
        <div className="space-y-4">
          {FAQ.map(item => (
            <div key={item.q} className="bg-white border border-gray-200 rounded-2xl p-5">
              <h3 className="font-semibold text-gray-900 mb-1">{item.q}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{item.a}</p>
            </div>
          ))}
        </div>
        <p className="text-sm text-gray-500 mt-10">
          <Link to="/gizlilik" className="underline">Gizlilik Politikası</Link> · <Link to="/kvkk" className="underline">KVKK Aydınlatma Metni</Link>
        </p>
      </main>
    </div>
  );
};

export default SupportPage;
